import { apiCreate } from './ApiBaseActions';
export const API_CREATE_PROFFIT_SEARCH_DEVICE_REGENERATE = 'API_CREATE_PROFFIT_SEARCH_DEVICE_REGENERATE';
export const API_CREATE_PROFFIT_SEARCH_DEVICE_ASSIGN = 'API_CREATE_PROFFIT_SEARCH_DEVICE_ASSIGN';
export const UPDATE_PROFFIT_SEARCH_DEVICE = 'UPDATE_PROFFIT_SEARCH_DEVICE';
/**
 * 端末情報の再発行
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: *}, type: *}}
 */
export const apiCreateProffitSearchDeviceRegenerate = (meta) => apiCreate(API_CREATE_PROFFIT_SEARCH_DEVICE_REGENERATE, '/proffit_search/registration_device/', meta || {});
/**
 * 端末の割り当て実行
 * @param token
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: *}, type: *}}
 */
export const apiCreateProffitSearchDeviceAssign = (token, meta) => apiCreate(API_CREATE_PROFFIT_SEARCH_DEVICE_ASSIGN, `/proffit_search/registration_device/${token}`, meta || {});
/**
 * 端末情報の更新
 * @param payload
 * @returns {{type: string, device}}
 */
export const updateProffitSearchDevice = (payload) => ({
    payload,
    type: UPDATE_PROFFIT_SEARCH_DEVICE,
});
